import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom"
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './redux/store';
import { Provider } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { SnackbarProvider } from './reusable_components/components/Snackbar';
import { CssBaseline, ThemeProvider } from '@mui/material';
import theme from './theme/theme';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale'
import { MsalProvider } from '@azure/msal-react';
import MsInstance from '../src/SocialLogin/MsInstance';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { WebSocketProvider } from './stompClient/WebSocketProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));

dayjs.extend(updateLocale)
dayjs.updateLocale('en', {
  weekStart: 1,
})

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <PersistGate loading={null} persistor={persistor}>
          <SnackbarProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <MsalProvider instance={MsInstance}>
                <GoogleOAuthProvider clientId="1082536633509-1b01halu3aosgt8huv5at3k4snjh4hrt.apps.googleusercontent.com">
                  {/* 👇 wrap App with WebSocketProvider */}
                  <WebSocketProvider>
                    <App />
                  </WebSocketProvider>
                </GoogleOAuthProvider>
              </MsalProvider>
            </LocalizationProvider>
          </SnackbarProvider>
        </PersistGate>
      </ThemeProvider>
    </Provider>
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
